// extracted by mini-css-extract-plugin
module.exports = {"coachSplashImage":"CoachesPage_coachSplashImage__CsWTh"};